/* packages/core/src/utils/timelineUtils.js */
import { buildProcessTree } from './processTreeBuilder';

/**
 * Segments the raw timeline into a display-ready list of messages, process groups, and effects.
 * @param {Array} timelineItems - Raw timeline events.
 * @param {Array} customEffectMatchers - Optional array of { matcher: (item) => boolean, rendererKey: string } objects.
 */
export const segmentTimeline = (timelineItems, customEffectMatchers = []) => {
  if (!timelineItems || timelineItems.length === 0) {
    return [];
  }

  const displayItems = [];
  const processedRootProcessIds = new Set();
  const rootProcessEventsMap = new Map();

  // First pass: Group process events by root ID
  for (const item of timelineItems) {
    if (item.process_ids && item.process_ids.length > 0) {
      const rootId = item.process_ids[0].id;
      if (!rootProcessEventsMap.has(rootId)) {
        rootProcessEventsMap.set(rootId, []);
      }
      rootProcessEventsMap.get(rootId).push(item);
    }
  }

  // Second pass: Generate display items
  for (const item of timelineItems) {
    // Check if this item matches a custom effect rule (e.g. InfoProcurer message)
    let matchedEffectKey = null;
    
    // FIX: Allow 'internal_command' (AGENT_COMPLETE) to be matched
    if (item.type === 'message' || item.type === 'agent_message' || item.type === 'internal_command') {
      const matcher = customEffectMatchers.find(m => m.matcher && m.matcher(item));
      if (matcher) {
        matchedEffectKey = matcher.rendererKey;
      }
    }

    if (matchedEffectKey) {
      displayItems.push({
        type: 'effect',
        data: { ...item, effect_key: matchedEffectKey },
        key: `effect-${item.id || Math.random()}`,
        timestamp: item.timestamp
      });
    }
    else if (item.type === 'message') {
      displayItems.push({ type: 'message', data: item, key: item.id || `msg-${Math.random()}` });
    }
    else if (item.type === 'resource_sync') {
      displayItems.push({
        type: 'effect',
        data: item.content,
        key: `effect-${item.id || Math.random()}`,
        timestamp: item.timestamp
      });
    }
    else if (item.process_ids && item.process_ids.length > 0) {
      const rootId = item.process_ids[0].id;
      if (!processedRootProcessIds.has(rootId)) {
        processedRootProcessIds.add(rootId);
        const processEvents = rootProcessEventsMap.get(rootId);
        const { tree } = buildProcessTree(processEvents);
        displayItems.push({
          type: 'process',
          data: {
            processTree: tree,
          },
          key: `proc-${rootId}`,
        });
      }
    }
  }

  return displayItems;
};